<template>
  <div class="c-tabs">
    <div class="c-tabs__headers">
      <div
        @click="SET_ACTIVE_INDEX(i)"
        class="c-tabs__headers__item"
        :class="{ 'c-tabs__headers__item__variant--active': i === activeIndex }"
        v-for="(item, i) in tabs"
        :key="i"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="c-tabs__body">
      <transition
        enter-active-class="from-right"
        leave-active-class="from-left"
        mode="out-in"
      >
        <slot :tab="tabs[activeIndex]" :name="tabs[activeIndex].tab"></slot>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      default: 0,
    },
    tabs: {
      default: () => [],
      required: true,
    },
    withRoute: {
      default: false,
      type: Boolean,
    },
    clearQuery: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      activeIndex: 0,
      scopedSlots: [],
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      handler() {
        if (this.withRoute) this.CHECK_WITH_ROUTE();
      },
    },
  },
  methods: {
    SET_ACTIVE_INDEX(index) {
      this.activeIndex = index;
      this.$emit("change:tab", index, this.tabs[index]);
      this.SET_ROUTE(index);
    },
    SET_ROUTE(index) {
      if (this.withRoute && this.tabs[index].tab !== this.$route.query.tab) {
        if (this.clearQuery) {
          this.$router.push({
            query: { tab: this.tabs[index].tab },
          });
        } else {
          this.$router.push({
            query: { ...this.$route.query, tab: this.tabs[index].tab },
          });
        }
      }
    },
    CHECK_WITH_ROUTE() {
      if (!this.withRoute) return (this.activeIndex = this.active);
      const queryTab = this.$route.query.tab;
      if (queryTab) {
        const index = this.tabs.findIndex((tab) => tab.tab === queryTab);
        if (index > -1) this.SET_ACTIVE_INDEX(index);
      }
    },
  },
  created() {
    this.CHECK_WITH_ROUTE();
  },
  mounted() {
    this.scopedSlots = Object.keys(this.$scopedSlots);
  },
};
</script>

<style></style>
